<template>
  <div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">设置</li>
      <li class="am-active">基本设置</li>
    </ol>
    <div class="am-form">
      <div class="am-form-group">
        <label for="title">网站标题</label>
        <input id="title" type="text" class="am-form-field am-radius" placeholder="请输入网站标题..." v-model="title"/>
      </div>
      <div class="am-form-group">
        <label for="description">网站描述</label>
        <input id="description" type="text" class="am-form-field am-radius" placeholder="请输入网站描述..." v-model="description"/>
      </div>
      <div class="am-form-group">
        <label for="keywords">网站关键字</label>
        <input id="keywords" type="text" class="am-form-field am-radius" placeholder="请输入网站描述..." v-model="keywords"/>
      </div>
      <div class="am-form-group">
        <label for="copyright">版权信息</label>
        <input id="copyright" type="text" class="am-form-field am-radius" placeholder="请输入版权信息..." v-model="copyright"/>
      </div>
      <div class="am-form-group">
        <label for="icp">ICP备案信息</label>
        <input id="icp" type="text" class="am-form-field am-radius" placeholder="请输入ICP备案信息..." v-model="icp"/>
      </div>
      <div class="am-form-group">
        <label for="webUrl">网站地址</label>
        <input id="webUrl" type="text" class="am-form-field am-radius" placeholder="请输入网站地址址..." v-model="webUrl"/>
      </div>
      <div class="am-form-group">
        <label for="fileUrl">文件服务器地址</label>
        <input id="fileUrl" type="text" class="am-form-field am-radius" placeholder="请输入文件服务器地址..." v-model="fileUrl"/>
      </div>
      <div class="am-form-group">
        <label for="mp3Url">网站背景音乐url</label>
        <input id="mp3Url" type="text" class="am-form-field am-radius" placeholder="请输入网站背景音乐url..." v-model="mp3Url"/>
      </div>
      <div class="am-form-group">
        <label for="mp3Title">网站背景音乐标题</label>
        <input id="mp3Title" type="text" class="am-form-field am-radius" placeholder="请输入网站背景音乐标题..." v-model="mp3Title"/>
      </div>
      <div class="am-form-group">
        <label for="bannerUrl">网站横幅图片url</label>
        <input id="bannerUrl" type="text" class="am-form-field am-radius" placeholder="请输入网站横幅图片url..." v-model="bannerUrl"/>
      </div>
      <div class="am-form-group">
        <label for="admirationUrl">网站赞赏图片url</label>
        <input id="admirationUrl" type="text" class="am-form-field am-radius" placeholder="请输入网站赞赏图片url..." v-model="admirationUrl"/>
      </div>
      <div class="am-form-group">
        <label for="grayscale">网站置灰</label>
        <input id="grayscale" type="text" class="am-form-field am-radius" placeholder="请输入true或false..." v-model="grayscale"/>
      </div>
      <div class="am-form-group am-margin-top">
        <button class="am-btn am-btn-primary am-btn-xs" @click="save">保存</button>
      </div>
    </div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">设置</li>
      <li class="am-active">基本设置</li>
    </ol>
  </div>
</template>

<script>
import { adminOptionGet, adminOptionSave } from '@/request'
import {Toast} from "mint-ui"
export default {
  name: 'EditOption',
  data () {
    return {
      title: '',
      description: '',
      keywords: '',
      copyright: '',
      icp: '',
      mp3Url: '',
      mp3Title: '',
      bannerUrl: '',
      admirationUrl: '',
      grayscale: ''
    }
  },
  mounted () {
    this.resetData()
  },
  watch: {
    $route: {
      handler: 'resetData'
    }
  },
  methods: {
    resetData () {
      adminOptionGet().then(res => {
        this.title = res.title
        this.description = res.description
        this.keywords = res.keywords
        this.copyright = res.copyright
        this.icp = res.icp
        this.webUrl = res.webUrl
        this.fileUrl = res.fileUrl
        this.mp3Url = res.mp3Url
        this.mp3Title = res.mp3Title
        this.bannerUrl = res.bannerUrl
        this.admirationUrl = res.admirationUrl
        this.grayscale = res.grayscale
      })
      document.title = `网站配置｜编辑`
    },
    save () {
      adminOptionSave({
        title: this.title,
        description: this.description,
        keywords: this.keywords,
        copyright: this.copyright,
        icp: this.icp,
        webUrl: this.webUrl,
        fileUrl: this.fileUrl,
        mp3Url: this.mp3Url,
        mp3Title: this.mp3Title,
        bannerUrl: this.bannerUrl,
        admirationUrl: this.admirationUrl,
        grayscale: this.grayscale
      }).then(() => {
        Toast("保存成功")
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditOption.vue